import _ from 'lodash';
import { CountriesAllDataAttributes, CountriesAllDataObject } from '../../types/CountriesList';
import { CurrencyDataObject, DropdownOption } from '../../types/Currencies';
import { DISABLED_CURRENCY_FOR_DROPDOWN, BRANDWISE_DISABLED_CURRENCIES } from '../Constants/Constants';
import { GetPreferredLanguageCountriesOptions } from '../GetCountriesData';

export const EURO_CURRENCY_OPTION = {
    value: "EUR",
    label: "Euro",
    icon: "countries/european-union"
};

const EURO_CURRENCY_DATA = {
    "value": "",
    "label": "",
    "icon": "countries/european-union",
    "dialingCode": "",
    "currencyCode": "EUR",
    "currencyName": "Euro",
    "currencySymbol": "€ ",
    "hasCurrency": true,
    "hasDialingCode": false,
    "showInCurrencyDropDown": true,
    "countryNameWithDialcode": ""
};

const EURO_CURRENCY_OBJECT = {
    "EUR": {
        ...EURO_CURRENCY_OPTION,
        symbol: "€ "
    }
}
export const getModifiedCountriesArray = (COUNTRIES_ALL_DATA: CountriesAllDataAttributes) => {
    const countryModifiedArray = _.cloneDeep(COUNTRIES_ALL_DATA?.options || []);
    countryModifiedArray.forEach((country) => {
        if (country?.haveDiffrentCurrency) {
            let obj = { ...country };
            obj.currencyCode = obj?.diffrentCurrencyCode ? obj.diffrentCurrencyCode : '';
            obj.currencySymbol = obj?.diffrentcurrencySymbol ? obj.diffrentcurrencySymbol : '';
            obj.currencyName = obj?.alternateCurrencyName ? obj.alternateCurrencyName : obj.currencyName;
            countryModifiedArray.push(obj);
        }
        return country;
    });
    return countryModifiedArray;
};

export const GetCurrenciesObjectMapping = () => {
    const COUNTRIES_ALL_DATA_JSON: CountriesAllDataAttributes = GetPreferredLanguageCountriesOptions();
    const countryModifiedArray = getModifiedCountriesArray(COUNTRIES_ALL_DATA_JSON);

    let currencyObject = countryModifiedArray.reduce((accumulator, index) => {
        return (index.hasCurrency ? {
            ...accumulator, [index.currencyCode]: {
                value: index.currencyCode,
                label: index.currencyName,
                icon: index.icon,
                symbol: index.currencySymbol
            }
        }
            :
            { ...accumulator });
    }, {});

    currencyObject = {
        ...currencyObject,
        ...EURO_CURRENCY_OBJECT
    };
    return currencyObject;
};

export const GetCurrenciesFlagIcon = (currency: string) => {
    const currenciesList = GetCurrenciesObjectMapping();
    const currenciesIconURL = currenciesList[currency]?.icon;
    if (currenciesIconURL) {
        return import(`../../assets/CountriesList/${currenciesIconURL}.svg`);
    }
    return '';
};

export const GetCurrencySymbol = (currency: string) => {
    const currenciesList = GetCurrenciesObjectMapping();
    const currencySymbol = currenciesList[currency]?.symbol ? currenciesList[currency]?.symbol : '';
    return currencySymbol;
};

export const GetCurrencyOptionList = () => {
    const COUNTRIES_ALL_DATA_JSON: CountriesAllDataAttributes = GetPreferredLanguageCountriesOptions();
    const countryModifiedArray: CountriesAllDataObject[] = getModifiedCountriesArray(COUNTRIES_ALL_DATA_JSON);
    let currencyOptionList: DropdownOption = {
        options: []
    };
    countryModifiedArray.forEach((countryData) => {
        if (countryData.hasCurrency && countryData.showInCurrencyDropDown) {
            let currencyData: CurrencyDataObject = {
                value: countryData.currencyCode,
                label: countryData.currencyName,
                icon: countryData.icon
            };
            const isCurrencyDisabled: boolean = DISABLED_CURRENCY_FOR_DROPDOWN[countryData.currencyCode];
            if (!isCurrencyDisabled) {
                currencyOptionList.options.push(currencyData);
            }
        }
    });
    currencyOptionList.options.push(EURO_CURRENCY_OPTION);
    return currencyOptionList;
};

export const GetBuySaleCurrencyOptionList = (referingCompnay: string | null) => {
    const COUNTRIES_ALL_DATA_JSON: CountriesAllDataAttributes = GetPreferredLanguageCountriesOptions();
    let countryModifiedArray: CountriesAllDataObject[] = getModifiedCountriesArray(COUNTRIES_ALL_DATA_JSON);
    countryModifiedArray.splice(1, 0, EURO_CURRENCY_DATA);

    let buyingCurrencyOptionList: DropdownOption = {
        options: []
    };
    let sellingCurrencyOptionList: DropdownOption = {
        options: []
    };
    const { buyingCurrency, sellingCurrency } = referingCompnay && BRANDWISE_DISABLED_CURRENCIES[referingCompnay] || {};
    countryModifiedArray.forEach((countryData) => {
        if (countryData.hasCurrency && countryData.showInCurrencyDropDown) {
            let currencyData: CurrencyDataObject = {
                value: countryData.currencyCode,
                label: countryData.currencyName,
                icon: countryData.icon
            };
            const isCurrencyDisabledForBuying: boolean = (buyingCurrency && buyingCurrency.length > 0 &&
                buyingCurrency.includes(countryData.currencyCode));
            const isCurrencyDisabledForSelling: boolean = (sellingCurrency && sellingCurrency.length > 0 &&
                sellingCurrency.includes(countryData.currencyCode));

            !isCurrencyDisabledForBuying && buyingCurrencyOptionList.options.push(currencyData);
            !isCurrencyDisabledForSelling && sellingCurrencyOptionList.options.push(currencyData);
        }
    });

    return ({
        buyingCurrencyOptionList,
        sellingCurrencyOptionList
    });
};

